import React, { createContext, useContext, useState, ReactNode } from 'react';

interface LayoutBannerContextType {
  topBanner: ReactNode;
  setTopBanner: (banner: ReactNode) => void;
}

const LayoutBannerContext = createContext<LayoutBannerContextType | undefined>(undefined);

export const LayoutBannerProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [topBanner, setTopBanner] = useState<ReactNode>(null);

  return (
    <LayoutBannerContext.Provider value={{ topBanner, setTopBanner }}>
      {children}
    </LayoutBannerContext.Provider>
  );
};

export const useLayoutBanner = (): LayoutBannerContextType => {
  const context = useContext(LayoutBannerContext);
  if (!context) {
    throw new Error('useLayoutBanner must be used within a LayoutBannerProvider');
  }
  return context;
};
